export default __webpack_public_path__ + "static/media/ps.0879f2a2.svg";